<template>
    <div id='company-user'>
        <el-dialog title="选择上级" :visible.sync="dialogVisible"  :close-on-click-modal="false" @close="cancelDialog" class="dialog-large" width="50%">
            <div class="company-user-header">
                <el-input clearable placeholder="请输入上级组织名称"  @keyup.enter.native="searchUserList" v-model="keyword" type="text" class="user-keyword">
                </el-input>
                <el-button type="primary" plain @click="searchUserList" style="margin-left: 10px">{{ $STR('COMMON.common.search', '查询') }}</el-button>
            </div>
            <div class="organizationClass">
                <el-table :data="organizationList" highlight-current-row style="min-height: 200px">
                    <el-table-column label="" width="30px">
                        <template slot-scope="scope">
                            <el-radio v-model="organization" :label="scope.row">&nbsp;</el-radio>
                        </template>
                    </el-table-column>
                    <el-table-column prop="name" label="组织名称" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="parentName" label="上级组织" :show-overflow-tooltip="true"></el-table-column>
                </el-table>
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="current"
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="rows"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="count">
                </el-pagination>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelDialog">{{$STR('COMMON.common.btn.cancel', '取消') }}</el-button>
                <el-button type="primary" plain @click="confirm">{{$STR('goods.SKUSet.list.confrim', '确认提交')}}</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    props: ['visible', 'updateLevelList'],
    data() {
        return {
            count: 0,
            current: 1,
            rows: 10,
            order: 'createDate',
            asc: false,
            keyword: '',
            organization: '',
            organizationList: [],
            dialogVisible: false
        };
    },
    created() {
    },
    watch: {
        visible(val) {
            this.dialogVisible = val;
            this.current = 1;
            this.searchUserList();
        }
    },
    methods: {
        // 确认选择负责人
        confirm () {
            this.$emit('confirm', this.organization);
            this.dialogVisible = false;
            this.$emit('close');
            this.organization = '';
        },
        close(userParam) {
            this.dialogVisible = false;
            this.$refs[userParam].resetFields();
        },
        searchUserList() {
            this.$http.post(WebApi.organization.getChildrenList, {
                current: this.current,
                rows: this.rows,
                order: this.order,
                asc: this.asc,
                keyString: this.keyword,
                updateLevelList: this.updateLevelList
            }).then(response => {
                if (response.data) {
                    if (response.data.rows) {
                        this.organizationList = response.data.rows;
                    }
                    this.count = response.data.total;
                }
            });
        },
        handleSizeChange(val) {
            this.rows = val;
            this.searchUserList();
        },
        handleCurrentChange(val) {
            this.current = val;
            this.searchUserList();
        },
        cancelDialog() {
            this.dialogVisible = false;
            this.$emit('close');
            this.organization = '';
        }
    }
};
</script>
<style>
    #company-user .el-pagination{
        margin-top: 5px;
    }
    #company-user .company-user-header {
        width: 100%;
        display: flex;
        justify-content: flex-start;
    }
    #company-user .user-keyword{
        width: 338px;
        float: right;
    }
    #company-user .item{
        padding-bottom: 30px;
    }
    #company-user{
        position: relative;
    }
    #company-user .el-card{
        position: absolute;
        top: 20px;
        left: 20px;
        width: 95%;
    }
    #company-user .cell{
        text-align: center;
        font-size: 14px;
    }
    #company-user .el-table-add-row{
        text-align: center;
        font-size: 16px;
        line-height: 16px;
        margin-top: 20px;
    }
    #company-user .text {
        font-size: 14px;
    }
    #company-user .el-card__body{
        padding-bottom: 20px;
    }
    /*#company-user .el-form-item{
        float: left;
        margin-left: 15px;
        margin-top: 10px;
        margin-right: 2%;
        width: 15%;
    }
    #company-user .el-form{
        padding-top: 40px;
        padding-bottom: 20px;
    }*/
    #company-user .add-user{
        float: right;
        margin-top: 10px;
        /*z-index: 10;*/
    }
    #company-user .add-user button {
        line-height: 30px;
        height: 36px;
        width: 80px;
        padding: 0;
    }
    #company-user .user-enable{
        margin-right: 0;
        width: 190px;
    }
    #company-user el-button--primary{
        padding: 0;
    }
    #company-user .el-form-item__error{
        padding-top: 1px;
    }
    #company-user .el-button+.el-button {
        margin: 0;
    }
    .organizationClass {
        display: flex;
        flex-direction: column;
        /*overflow-y: auto;*/
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/views/cloud/organization/parentOrganization.vue